import styled from 'styled-components';

const TextArea = styled.textarea`
    font-size: ${({theme:{input:{size}}}) => size};
    margin: 5px 0;
    padding: 4px 8px;
    font-family: inherit;
`;

export default TextArea;